var render, staticRenderFns
import script from "./conditional-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./conditional-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0392ae",
  null
  
)

export default component.exports